import React from "react";

export default function Web_W3JS() {
  return (
    <div>
      <h1>What is W3.JS</h1>
      <p>
        Route: <code>/web/w3js</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
